import { FirebaseApp } from 'firebase/app'
import { Auth, getAuth } from 'firebase/auth'
import { Firestore, getFirestore } from 'firebase/firestore'
import { Functions, getFunctions } from 'firebase/functions'
import { FirebaseStorage, getStorage } from 'firebase/storage'
import { createContext, PropsWithChildren, useContext, useState } from 'react'
export const FirebaseAppContext = createContext<
  Partial<{
    app: FirebaseApp
    storage: FirebaseStorage
    auth: Auth
    firestore: Firestore
    functions: Functions
  }>
>({})

export const FirebaseAppProvider = ({ app, children }: PropsWithChildren<{ app: FirebaseApp }>) => {
  const [storage] = useState(getStorage(app))
  const [auth] = useState(getAuth(app))
  const [firestore] = useState(getFirestore(app))
  const [functions] = useState(getFunctions(app))
  return (
    <FirebaseAppContext.Provider value={{ app, storage, auth, firestore, functions }}>
      {children}
    </FirebaseAppContext.Provider>
  )
}

export const useFirebaseApp = () => useContext(FirebaseAppContext)
